import { render } from "./DeviationVehicleTable.vue?vue&type=template&id=2dbf9857"
import script from "./DeviationVehicleTable.vue?vue&type=script&lang=ts"
export * from "./DeviationVehicleTable.vue?vue&type=script&lang=ts"
script.render = render

export default script